/** 启动longding */

let loading: HTMLElement | null = null;
let isAddLoading = true; // 是否增加loading

/** 增加loading */
export const addStartLoading = () => {
  if (!isAddLoading) {
    // loading 插入到body节点，增加 isAddLoading 控制，避免先调用 hideStartLoading 导致 loading 一直在
    return;
  }

  loading = document.createElement('div');
  loading.className = 'ovopark-start-loading';
  loading.innerHTML = `
    <style>
      .ovopark-start-loading {
        position: absolute;
        top: 50%;
        left: 50%;
        z-index: 999990;
        font-size: 0;
        transform: translate(-50%, -50%);
      }
      .ovopark-start-loading svg {
        width: 9.6vw;
        height: 9.6vw;
        max-width: 64px;
        max-height: 64px;
        animation: ovopark-start-loading-rotate 1s linear infinite;
      }
      @keyframes ovopark-start-loading-rotate {
        0% {
          transform: rotate(0deg);
        }
        100% {
          transform: rotate(360deg);
        }
      }
    </style>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36">
      <path d="M18.0002044,0 C27.9248822,0 36,8.0751178 36,18.0002044 C36,27.9252909 27.9248822,36.0004087 18.0002044,36.0004087 C8.0751178,36.0004087 0,27.9252909 0,18.0002044 C0,8.0751178 8.0751178,0 18.0002044,0 Z M18.0002044,5.35738859 C11.0286915,5.35738859 5.35697985,11.0286915 5.35697985,18.0002044 C5.35697985,24.9713085 11.0286915,30.6430202 18.0002044,30.6430202 C24.9717173,30.6430202 30.6430202,24.9713085 30.6430202,18.0002044 C30.6430202,11.0286915 24.9717173,5.35738859 18.0002044,5.35738859 Z M25.064788,20.447346 L27.4032041,21.2448027 C26.4287619,24.1076355 24.1434823,26.413761 21.2920942,27.413954 L20.4754266,25.0857565 C22.6156026,24.3328527 24.3319126,22.5993755 25.064788,20.447346 Z" fill="#F90" fill-rule="evenodd"/>
    </svg>
  `;
  document.body.appendChild(loading!);
};

/** 隐藏loading */
export const hideStartLoading = () => {
  isAddLoading = false;
  if (loading) {
    loading.remove();
    loading = null;
  }
};
